import axios from "axios";

export default class ApiService {
  HeaderParam = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "content-type": "application/json",
    Accept: "application/json",
  };

  commonapiall = (url, params, method, type, item) => {
    return axios(url, {
      method: method,
      headers: params,
      data: item,
    })
      .then((response) => {
        if (response.data.status === 403) {
          this.logout();
        } else if (
          response.data.status === 423 &&
          response.data.logout_reason === 4
        ) {
          localStorage.setItem("userLockAttempt", 1);
          localStorage.setItem("userLockAttemptReason", response.data.message);
        } else {
          return response.data;
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  getAccessCodeBannerImage(item) {
    let url = "/api/u/getAccessCodeBannerImage";
    return this.commonapiall(url, this.HeaderParam, "POST", 0, item);
  }

  checkPersonalMessage(item) {
    let URL = "/api/verifyPersonalMessage";
    return this.commonapiall(URL, this.HeaderParam, "POST", 0, item);
  }
}
